import { render, staticRenderFns } from "./ReportFormPersonalDataAlt.vue?vue&type=template&id=2883e67c&"
import script from "./ReportFormPersonalDataAlt.vue?vue&type=script&lang=ts&"
export * from "./ReportFormPersonalDataAlt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VForm,VTextField})
